import { IAppState } from 'shared/common/state';

export const selectEarlyAccessData = (state: IAppState) => state.earlyAccessData;
